import { useEffect, useRef, RefObject } from 'react'

export const useClickOutside = (
    refs: RefObject<HTMLElement | null>[],
    handler: () => void,
    enabled: boolean = true
): void => {
    const handlerRef = useRef(handler)
    const refsRef = useRef(refs)

    handlerRef.current = handler
    refsRef.current = refs

    useEffect(() => {
        if (!enabled) return

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node
            const isOutside = refsRef.current.every(ref => {
                return !ref.current || !ref.current.contains(target)
            })

            if (isOutside) {
                handlerRef.current()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [enabled])
}

export const useClickOutsideSingle = (
    ref: RefObject<HTMLElement | null>,
    handler: () => void,
    enabled: boolean = true
): void => {
    useClickOutside([ref], handler, enabled)
}
